import React from "react";
import "./styles/therapy.css";
import Conversation from "../../assets/conversation.jpg"; // Replace with your actual image path
import trees from "../../assets/trees.mp4"; // Placeholder path for your video
import ServiceWarning from "../../components/ServiceWarning";

const DBT = () => {
  return (
    <section className="therapy-section">
      <div className="therapy-card">
        <div className="video-banner">
          <video className="therapy-video" autoPlay muted loop playsInline>
            <source src={trees} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="therapy-content">
          <h1>
            Dialectical Behavioural Therapy (DBT) and the treatment of
            Borderline Personality Disorder
          </h1>
          <p>
            Dialectical Behaviour Therapy (DBT) is an evidence-based treatment
            developed for individuals who experience intense emotional
            dysregulation, unstable interpersonal relationships and chronic
            distress. Among others, DBT is also the recommended treatment for
            borderline personality disorder.
          </p>
          <p>
            My approach to DBT is grounded in both clinical experience and
            flexibility—drawing from the structured core components of the model
            while adapting them to each individual&#39;s goals and context. DBT
            utilizes four core set of skills for managing emotions, improving
            relationships, and coping with distress:
          </p>
          <ul className="styled-list">
            <li>
              <b>Mindfulness:</b> Focuses on increasing awareness of the present
              moment and observing thoughts and feelings without judgment.
            </li>

            <li>
              <b>Distress Tolerance:</b> Equips you with skills to cope with
              intense emotions and difficult situations without resorting to
              self-destructive or harmful behaviors.
            </li>
            <li>
              <b>Emotion Regulation:</b> Helps you understand and manage
              emotions effectively, including identifying, labeling, and
              changing emotional responses.
            </li>
            <li>
              <b>Interpersonal Effectiveness:</b> Teaches skills for building
              and maintaining healthy relationships, including assertiveness,
              clear communication, and boundary setting.
            </li>
          </ul>
          <p>
            These modules are designed to be integrated and build upon each
            other, ultimately supporting individuals in developing a more
            stable, balanced, and fulfilling life. While I do not currently
            facilitate DBT groups, I have run them for many years and draw on
            that experience to integrate DBT tools and strategies into
            individual therapy as they become relevant. This allows for a
            personalized, flexible application of the model while maintaining
            its clinical integrity and effectiveness.
          </p>
        </div>

        <div className="bottom-image-wrapper">
          <img
            src={Conversation}
            alt="Therapy session representation"
            className="therapy-image"
          />
        </div>
      </div>
      <ServiceWarning />
    </section>
  );
};

export default DBT;
